export default __webpack_public_path__ + "static/media/1850.60d553f1.png";